export default __webpack_public_path__ + "static/media/Afpb.a17fdb19.cms";